import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-40be8835"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"text-align":"left","margin":".3rem 0"} }
const _hoisted_2 = { class: "items-selection-demands-holder" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "В заказе есть запрос на подбор запчастей", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "только замены", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "только оригинал", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 1,
  style: {"margin":"1rem 0","text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_order_items_search_component = _resolveComponent("order-items-search-component")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_search_items_by_part_number_component = _resolveComponent("search-items-by-part-number-component")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 8 }),
        _createVNode(_component_el_col, {
          span: 8,
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_order_items_search_component, {
              disabled: _ctx.itemsSearchDisabled,
              onSearchInCatalogs: _ctx.onSeachItemInCatalogsPressed,
              onItemPicked: _ctx.onItemPicked
            }, null, 8, ["disabled", "onSearchInCatalogs", "onItemPicked"]),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_link, {
                type: "primary",
                underline: false,
                onClick: _ctx.onShowAddItemSelectionDemandFormClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode("добавить запчасть для подбора")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 })
      ]),
      _: 1
    }),
    (_ctx.orderItemDemandsTableData?.length)
      ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }),
            _createVNode(_component_el_col, {
              span: 12,
              align: "center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_alert, {
                    type: "warning",
                    "show-icon": "",
                    closable: false
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table, {
                    "show-header": false,
                    data: _ctx.orderItemDemandsTableData
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, null, {
                        default: _withCtx((scope) => [
                          (scope.row.partNumber)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                                _createElementVNode("strong", null, _toDisplayString(scope.row.partNumber.toUpperCase()), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, _toDisplayString(scope.row.demand), 1),
                          (scope.row.oemOnly === false)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _hoisted_7))
                            : _createCommentVNode("", true),
                          (scope.row.oemOnly === true)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _hoisted_10))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        width: "155",
                        align: "right"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_button, {
                            icon: _ctx.editIcon,
                            circle: "",
                            onClick: () => _ctx.onShowEditItemSelectionDemandClick(scope.row)
                          }, null, 8, ["icon", "onClick"]),
                          _createVNode(_component_el_button, {
                            icon: _ctx.deleteIcon,
                            circle: "",
                            onClick: () => _ctx.deleteItemSelectionDemandClick(scope.row.id)
                          }, null, 8, ["icon", "onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            (_ctx.orderItemsTableData.length)
              ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  style: {"margin":"1rem 0"},
                  "show-summary": "",
                  "summary-method": _ctx.getSummaries,
                  data: _ctx.orderItemsTableData,
                  "default-sort": { prop: 'partNumber', order: 'descending' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "Деталь",
                      sortable: "",
                      prop: "item.partNumber",
                      "column-key": "partNumber"
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.isItemValid)
                          ? (_openBlock(), _createBlock(_component_el_link, {
                              key: 0,
                              type: "primary",
                              onClick: () => _ctx.onItemNumberLinkClick(scope.row)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.item.partNumber.toUpperCase()), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : (_openBlock(), _createBlock(_component_el_text, {
                              key: 1,
                              type: "danger"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.item.partNumber), 1)
                              ]),
                              _: 2
                            }, 1024)),
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_text, {
                            type: "info",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.row.item.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Производитель",
                      prop: "item.manufacturer.name",
                      sortable: "",
                      "column-key": "manufacturer"
                    }),
                    _createVNode(_component_el_table_column, {
                      width: "260",
                      label: "Группа",
                      "column-key": "group"
                    }, {
                      default: _withCtx((scope) => [
                        (!scope.row.isItemValid)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              type: "danger",
                              effect: "dark",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" запчасть не была создана ")
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock("text", _hoisted_11, _toDisplayString(scope.row.item.group?.name), 1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      width: "180",
                      label: "Ед. измерения",
                      prop: "item.measureUnit.name",
                      "column-key": "measureUnit"
                    }),
                    _createVNode(_component_el_table_column, {
                      width: "180",
                      label: "Количество"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input_number, {
                          min: 0,
                          size: "small",
                          modelValue: scope.row.count,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.count) = $event),
                          onInput: () => _ctx.onItemsCountChange(scope.row)
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      width: "180",
                      label: "Скидка (+/-, %)"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input_number, {
                          min: -100,
                          max: 100,
                          size: "small",
                          modelValue: scope.row.discountPercent,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.discountPercent) = $event),
                          onInput: () => _ctx.onItemDiscountChange(scope.row)
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      width: "180",
                      label: "Своя цена"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input_number, {
                          size: "small",
                          min: 0,
                          controls: false,
                          class: _normalizeClass({'input-invalid': !scope.row.isItemPriceValid}),
                          modelValue: scope.row.overridenPrice,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.overridenPrice) = $event),
                          onInput: () => _ctx.onItemOverridenPriceChange(scope.row)
                        }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      width: "180",
                      label: "Закупка (р.)",
                      "column-key": "purchasePrice"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input_number, {
                          size: "small",
                          class: _normalizeClass({'input-invalid': !scope.row.isItemPriceValid}),
                          min: 0,
                          controls: false,
                          modelValue: scope.row.purchasePrice,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.purchasePrice) = $event),
                          onInput: () => _ctx.onItemPriceChange(scope.row)
                        }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      width: "180",
                      label: "Маржа (%)",
                      "column-key": "marginPrice"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(_ctx.getMarginPercent(scope.row.purchasePrice)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      width: "180",
                      label: "Итого (р.)",
                      prop: "totalPrice",
                      "column-key": "totalPrice"
                    }),
                    _createVNode(_component_el_table_column, {
                      width: "74",
                      align: "center"
                    }, {
                      default: _withCtx((scope) => [
                        (!scope.row.isItemValid)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              onClick: () => _ctx.onAddMissingItemClick(scope.row.item),
                              type: "danger",
                              icon: _ctx.plusIcon,
                              circle: "",
                              plain: ""
                            }, null, 8, ["onClick", "icon"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      width: "74",
                      align: "center"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          icon: _ctx.deleteIcon,
                          circle: "",
                          onClick: () => _ctx.onTableDeleteItemClick(scope.row.vmId)
                        }, null, 8, ["icon", "onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["summary-method", "data"])), [
                  [_directive_loading, _ctx.orderItemsLoading]
                ])
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_el_text, { type: "info" }, {
                    default: _withCtx(() => [
                      _createTextVNode("В заказ-наряде нет запчастей ☹️")
                    ]),
                    _: 1
                  })
                ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isAddOrderItemDemandsDialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isAddOrderItemDemandsDialogVisible) = $event)),
      width: "700"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "addItemSelectionDemandForm",
          rules: _ctx.itemDemandFormRules,
          model: _ctx.itemDemandForm
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Артикул запчасти",
              "label-position": "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "OEM-номер, замена, кросс",
                  modelValue: _ctx.itemDemandForm.partNumber,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemDemandForm.partNumber) = $event)),
                  max: "250"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Описание запчасти для подбора",
              "label-position": "top",
              prop: "demand"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.itemDemandForm.demand,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemDemandForm.demand) = $event)),
                  style: {"width":"100%"},
                  autosize: { minRows: 2, maxRows: 4 },
                  type: "textarea",
                  max: "5000",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Тип запчасти",
              "label-position": "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.itemDemandForm.oemOnly,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.itemDemandForm.oemOnly) = $event)),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_button, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("Любая")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio_button, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("Только оригинал")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio_button, { value: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode("Только замены")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider, { style: {"margin":".3rem 0 1rem"} }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                (_ctx.itemDemandForm.isCreatingMode == true)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      onClick: _ctx.onAddItemSelectionDemandClick,
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Добавить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      onClick: _ctx.onUpdateItemSelectionDemandClick,
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Сохранить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_search_items_by_part_number_component, {
      onItemSelected: _ctx.onItemSelected,
      onClosed: _cache[4] || (_cache[4] = () => _ctx.itemsDialogVisible = false),
      items: _ctx.itemsDialogData,
      "part-number": _ctx.itemsDialogPartNumber,
      visible: _ctx.itemsDialogVisible
    }, null, 8, ["onItemSelected", "items", "part-number", "visible"])
  ], 64))
}